<style lang="less">
.dcGive {
  background: linear-gradient(0deg, #ca2f13 0%, #e75816 100%);
}
.idxBanner {
  img {
    width: 100%;
  }
}
.dcAwBanner {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 6.76rem;
  background: url('https://imgcdn-prd.pydp888.com/file/0/1/266583/20201127/0b7885cbe55d1fbc35e03ed62a069f8f.jpg') no-repeat 50% 0;
  background-size: 100%;
  font-size: 0.24rem;
  &__info {
    position: absolute;
    top: 1.9rem;
    left: 0;
    width: 100%;
    text-align: center;
  }
  &__infoMsg {
    margin: 0;
    padding: 0.1rem 0;
    font-size: 0.28rem;
  }
}
.dcGiver {
  margin: 0;
  padding: 0;
  dt,
  dd {
    display: inline-block;
    vertical-align: middle;
    margin: 0;
    padding: 0;
  }
  dd {
    padding: 0 0.05rem;
  }
  .k-user-logo {
    width: 0.8rem;
    height: 0.8rem;
  }
}
// .dcGive {
//   padding: .1rem 0 0;
// }
.dcAwardLink {
  text-align: center;
  padding: 0.2rem 0;
  font-size: 0.24rem;
  a,
  a:visited {
    color: #fff;
  }
}
</style>
<template>
  <wz-page v-if="code" name="dcAward" :is-loading="isLoading">
    <app-account-bar />
    <div class="dcAwBanner">
      <div v-if="giveUser" class="dcAwBanner__info">
        <dl class="dcGiver">
          <dt>这是</dt>
          <dd><k-user-logo :src="giveUser.logoSm" :lv="giveUser.lvKey" /></dd>
          <dt>{{ giveUser.nick }}</dt>
        </dl>
        <p class="dcAwBanner__infoMsg">送出的新人福利</p>
      </div>
    </div>
    <dc-award />
    <dc-btn-area />
    <div class="dcAwardLink" v-if="isGiver">
      <router-link to="/dc">我的赠送&gt;&gt;</router-link>
    </div>
    <dc-rule />
  </wz-page>
  <wz-page v-else name="dcIndex" :is-loading="isLoading">
    <app-account-bar />
    <div class="idxBanner"><k-cdn-img src="https://imgcdn-prd.pydp888.com/file/0/1/266583/20201127/68f330cbda033fd8add3089bc6b6da91.jpg" /></div>
    <div class="dcGive">
      <dc-give-list />
    </div>
    <dc-rule />
  </wz-page>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import DcRule from './comp/dc-rule.vue'
import DcGiveList from './comp/dc-give-list.vue'
import DcAward from './comp/dc-award.vue'
import DcBtnArea from './comp/dc-btn-area.vue'

export default {
  components: {
    DcRule,
    DcGiveList,
    DcAward,
    DcBtnArea
  },
  data() {
    return {
      isLoading: true
    }
  },
  computed: {
    ...mapGetters('account', [
      'myInfo',
      'myUid',
      'isValidMobile',
      'myNick',
      'isLogined'
    ]),
    ...mapGetters('laxin', ['inDCService']),
    ...mapGetters('laxin/dc', ['giveUid', 'giveUser', 'isGiver']),
    query() {
      return this.$route.query || {}
    },
    code() {
      return this.query.c || ''
    }
  },
  methods: {
    ...mapActions('account', ['goLogin', 'goLogout']),
    ...mapActions('laxin', ['loadPriv']),
    ...mapActions('laxin/dc', ['loadGiveAwards', 'loadAwardInfo', 'bind']),
    ...mapActions('share', ['setShare']),
    async load() {
      const { code } = this
      this.isLoading = true
      await this.loadPriv()

      const { myUid, isValidMobile, inDCService } = this
      if (code) {
        await this.loadAwardInfo({ awardId: code })
        this.bind()
      } else if (inDCService) {
        await this.loadGiveAwards()
      } else if (isValidMobile) {
        this.$router.replace(`/da?uid=${myUid}`)
      } else {
        this.goLogin()
      }

      this.isLoading = false
      this.setShare({
        description: '520版+Level2免费送啦！数量有限先到先得！'
      })
    }
  },
  watch: {
    code: 'load'
  },
  mounted() {
    this.load()
  }
}
</script>
